// share-providers/facebook.js
export const shareOnFacebook = (url, title = "") => {
  if (!url) {
    console.error("URL is required for Facebook sharing")
    return
  }

  const shareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
    url
  )}`
  window.open(shareUrl, "facebook-share-dialog", "width=626,height=436")
}
